<template>
    <div class="col-md-3 col-lg-4 mb-2">
        <div class="card cursor-pointer mb-0 aluno_card p-2">
            <div class="d-flex float-right">
                <i class="far fa-trash lixoIcon cursor-pointer font-13" @click="deletar"></i>
            </div>
            <div class="d-flex justify-content-between " @click="abrir">
                <div class="justify-content-center">
                    <div class="">
                        <span class="unicoLimitador font-16 font-weight-bold">{{ aluno.nomeCompleto }}</span>
                        <span class="unicoLimitador font-14 d-block">
                            <span class="color-theme mr-1">Capelão:</span>{{aluno.nomeAdm}}
                        </span>
                        <span class="unicoLimitador font-13 d-block">
                            <span class="color-theme mr-1">Data:</span>{{aluno.dataAgendamento == null ? 'Sem agendamento' : new Date(aluno.dataAgendamento).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1, year: 'numeric', month: 'numeric', day: 'numeric'}) }} {{aluno.dataAgendamento == null ? '' : '| ' + new Date(aluno.dataAgendamento).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1, hour: 'numeric', minute: 'numeric',hour12: false}) }}
                        </span>
                        <span class="unicoLimitador font-13 d-block">
                            <span class="color-theme mr-1">Nível:</span>{{aluno.nivel}} pontos
                        </span>
                        
                    </div>
                </div>
            </div>
                
        </div>
    </div>
</template>

<script>

export default {
    name: 'Aluno',
    props: ['aluno', 'index'],
    methods: {
        abrir : function () {
            this.$emit('abrir', this.aluno)
        },
        deletar : function () {
            this.$emit('deleteAluno', {'id': this.aluno.id, 'index': this.index})
        }
    }
}

</script>

<style>
.borderAgendar {
	border: solid blue 1px;
}

.aluno_botao {
   right: 10px;
   top: 10px;
   position: absolute;
}

.aluno_botao button {
   margin: 3px;
   height: 60px;
   width: 60px;
}

.switch input[type="checkbox"]:not(:checked)+.slider {
   background-color: #3c3e42
}

input[type="date"]::-webkit-calendar-picker-indicator {
   filter: invert(50%);
}

.slide-up-enter-active {
   transition: all 0.4s;
}

.slide-up-enter {
   transform: translateY(-100%);
   opacity: 0;
}

.slide-up-leave-to {
   transform: translateY(-100%);
   opacity: 0;
}

.custom-hover-class {
   background-color: red;
   color: white;
}

.ajusteBtn {
   margin-top: 32px;
}

.cardHeader {
	border-bottom: solid white 1px;
	
}

.aluno_card:hover {
	/* border-left: 5px solid #0392CF !important; */
	background-color: rgb(51, 51, 51) !important;
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

.lixoIcon {
    color: rgb(165, 57, 57);
}
div .lixoIcon:hover {
    color: rgb(255, 55, 55);
}
</style>